import { WEB_SERVICES } from "../../../../bitSagas/webServices";
import { USER_TYPE } from '../../../../bitConstants/constants';
import { WEBSERVICE_ERRORS } from '../../../errorCatalog';

export const getHandledErrors = (errorToPrint) => {
  const handledErrors = {
    common: {},
    [`user_${USER_TYPE.TELCO}`]: {},
    [`user_${USER_TYPE.OPEN}`]: {

    },
  }

  return handledErrors;
}
